import type { BuyNowInitializer } from '@ctct/application-layer';
import { ThankYouWidget, useThankYouWidget } from '@ctct/react-app-layer';

import './buy-now-thank-you.scss';

interface Props {
  initializer: BuyNowInitializer;
}

const externalHooks = {
  useReturnUrl: () => null,
  useReturnLabel: () => null,
  useIsXeroAddonSelected: () => false,
};

export const BuyNowThankYouPage = ({ initializer }: Props) => {
  const props = useThankYouWidget({
    initializer,
    externalHooks,
  });

  return (
    <div className="payflow-buy-now-thank-you">
      <ThankYouWidget {...props} />
    </div>
  );
};
